// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gY36","title":"styles_title__w9krB"};